import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Component, Injectable, Input, ViewChild} from "@angular/core";
import {AdminEnkelGruppeModell, GruppeId, GruppeRessursClient, SøkeresultatModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('ListGruppeBrukerMalKomponent');
/**
 *
 * Viser grupper som bruker mal
 */
@Component({
    selector: 'list-gruppe-bruker-mal',
    templateUrl: './list-gruppe-bruker-mal.html',
    styleUrl: './list-gruppe-bruker-mal.scss',
    imports: [
        MatPaginatorModule,
        TranslateModule,
    ]
})
export class ListGruppeBrukerMalKomponent {
    static ajsSelector = 'listGruppeBrukerMal';

    private _gruppeId!: GruppeId;

    sideStoerrelse = 50;
    private sideIndex = 0;

    grupper:AdminEnkelGruppeModell[] = []

    constructor(private avhengigheter: ListGruppeBrukerMalKomponentAvhengigheter) {
    }

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    @Input({required: true}) set gruppeId(gruppeId: GruppeId) {
        this._gruppeId = gruppeId;
        this.søk();
    }

    get gruppeId(){
        return this._gruppeId;
    }

    handlePageEvent(e: PageEvent) {
        this.sideStoerrelse = e.pageSize;
        this.sideIndex  = e.pageIndex;
        this.søk()
    }

    private søk() {
        this.avhengigheter.søkEtterGrupper(this.gruppeId, this.offset(), this.sideStoerrelse).then(resultat => {
            this.paginator.length = resultat.totalantall
            this.grupper = resultat.treff
        })
    }

    private offset():number{
        return this.sideStoerrelse * this.sideIndex;
    }

}

@Injectable()
export class ListGruppeBrukerMalKomponentAvhengigheter {

    constructor(private gruppeRessursClient: GruppeRessursClient) {
    }

    søkEtterGrupper(gruppeId: GruppeId, offset: number, antall: number): Promise<SøkeresultatModell<AdminEnkelGruppeModell>> {
        return this.gruppeRessursClient.finnGrupperSomBrukerMal(gruppeId, {offset: offset, antall: antall}).somPromise();
    }
}
